import { Link } from 'gatsby-plugin-react-i18next';

import ArrowRight from '@/images/icon-arrow-right.svg';

type LinkItem = {
  id: string;
  title: string;
  url: string;
};

type LinkListProps = {
  links: LinkItem[];
};

export const LinkList = ({ links }: LinkListProps) => (
  <div className={'accordion'}>
    {links.map((link) => (
      <div className={'accordion__item'} key={link.id}>
        <Link className={'accordion__button'} to={link.url}>
          {link.title}
          <ArrowRight />
        </Link>
      </div>
    ))}
  </div>
);
